export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.48.0-de48ae84e.svg#star","viewBox":"0 0 18.5 17.69"}